import axios from "axios"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

export default {
  mails: {
    getMails() {
      let url = buildUrl("mail/mails")
      return axios.get(url, buildOptions())
    },
    getFolders() {
      let url = buildUrl("mail/folders")
      return axios.get(url, buildOptions())
    },
    syncEmails() {
      let url = buildUrl("mail/sync")
      return axios.get(url, buildOptions())
    },
    categorizeEmail(emailId, category, studioId) {
      let url = buildUrl("mail/categorize")
      return axios.post(url, { emailId, category, studioId }, buildOptions())
    },
    sendEmail(to, subject, text, replyTo) {
      let url = buildUrl("mail/send")
      return axios.post(url, { to, subject, text, replyTo }, buildOptions())
    },
  },
}
